<ng-template #modal let-hide="close">
  <div class="modal-header">
    <h4 i18n class="modal-title">My settings</h4>
    <button class="border-0 p-0" title="Close this modal" i18n-title (click)="hide()">
      <my-global-icon iconName="cross"></my-global-icon>
    </button>
  </div>

  <div class="modal-body">
    <my-alert i18n type="primary">These settings apply only to your session on this instance.</my-alert>

    <h5 i18n class="section-label mt-4 mb-3">INTERFACE</h5>

    @if (!isUserLoggedIn()) {
      <my-user-interface-settings
        [user]="user" [userInformationLoaded]="userInformationLoaded" reactiveUpdate="true" notifyOnUpdate="true"
      ></my-user-interface-settings>
    }

    <h5 i18n class="section-label mt-4 mb-3">VIDEOS</h5>

    @if (!isUserLoggedIn()) {
      <my-user-video-settings
        [user]="user" [userInformationLoaded]="userInformationLoaded" reactiveUpdate="true" notifyOnUpdate="true"
        >
      </my-user-video-settings>
    }
  </div>
</ng-template>
